var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000179609121626421453500000006388666180754422432_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PNG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302.2 0h-191.1c-18.4 0-33.4 15-33.4 33.5v445.1c0 18.5 15 33.4 33.5 33.5h335.5c18.5 0 33.4-15 33.5-33.5l-1-330.6z",
    fill: "#4eb3f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.2 0-.5 144.5s.5 3.5 3.5 3.5h174z",
    fill: "#07c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m45.5 246.7h337.6c7.5 0 13.6 6.1 13.6 13.6v150.8c0 7.5-6.1 13.6-13.6 13.6h-337.6c-7.5 0-13.6-6.1-13.6-13.6v-150.8c0-7.5 6.1-13.6 13.6-13.6z",
    fill: "#07c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.2 299.1h38.5c8.4 0 14.7 2 18.8 6s6.3 9.7 6.3 17c0 7.6-2.3 13.5-6.8 17.7s-11.5 6.4-20.8 6.4h-12.7v27.8h-23.3zm23.2 32h5.7c4.5 0 7.6-.8 9.4-2.3s2.8-3.7 2.7-6c.1-2.2-.8-4.4-2.4-6s-4.5-2.5-8.8-2.5h-6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172 299.1h21.6l28.2 41.4v-41.4h21.8v74.9h-21.8l-28-41.1v41.1h-21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.6 346.9v-15.6h35.8v31.9c-6.8 4.7-12.9 7.8-18.2 9.5-6.1 1.8-12.4 2.7-18.7 2.5-8.9 0-16.1-1.5-21.7-4.5-5.6-3.1-10.2-7.8-13-13.5-3.2-6.4-4.8-13.5-4.6-20.6 0-8.2 1.7-15.3 5.1-21.3s8.5-10.9 14.8-13.8c5.1-2.4 11.9-3.6 20.5-3.6 8.3 0 14.5.8 18.6 2.2 4 1.4 7.5 3.8 10.2 7 2.9 3.5 5 7.6 6.1 12l-22.3 4c-.8-2.6-2.4-4.9-4.7-6.5-2.5-1.6-5.4-2.4-8.4-2.2-4.6-.2-9.1 1.8-12.1 5.3s-4.5 9.1-4.5 16.7c0 8.1 1.5 13.9 4.6 17.4 3 3.5 7.3 5.2 12.8 5.2 2.5 0 5-.4 7.4-1.1 2.8-1 5.5-2.3 8.1-3.8v-7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.bbff40bc2d8e1c855d8628370a175e6f.svg";
export { ForwardRef as ReactComponent };